import React from 'react';



const StatusComponent = ({ formValue, name }) => {
  switch (name) {
    case 'purchase order':
      return <>
      {formValue.status !== ' ' && (
        <div id='status-container flex'>
          <ul className='inner-wrapper items-center'>
            <li className={ formValue.status === 'rfq' ? 'draft-disabled first draft draft-status' : 'first draft-status draft-transparent' }>
              RFQ
            </li>
            <li className = {formValue.status === 'rfq_send' ? 'middle middle-status' : 'middle-status middle-transparent' }>
              RFQ SENT
            </li>
            {formValue.status === 'received' && <li className = {formValue.status === 'purchase_order' ? 'middle middle-status' : 'middle-status middle-transparent' }>
              PURCHASE ORDER
            </li>}
            {(formValue.status === 'purchase_order' || formValue.status === 'rfq') && <li className={ formValue.status === 'purchase_order' ? 'posted posted-status' : 'posted-status posted-transparent' }>
              PURCHASE ORDER
            </li>}
            {formValue.status === 'received' && <li className={ formValue.status === 'received' ? 'posted posted-status' : 'posted-status posted-transparent' }>
              RECEIVED
            </li>}
            
          </ul>
        </div>
      )}
      </>
      
    case 'TRANSFERS':
      return <>
      {formValue.status !== ' ' && (
        <div id='status-container flex'>
          <ul className='inner-wrapper items-center'>
            <li className={ formValue.status === 'draft' ? 'draft-disabled first draft draft-status' : 'first draft-status draft-transparent' }>
              DRAFT
            </li>
            <li className = {formValue.status === 'waiting' ? 'middle middle-status' : 'middle-status middle-transparent' }>
              WAITING
            </li>
            <li className = {formValue.status === 'ready' ? 'middle middle-status' : 'middle-status middle-transparent' }>
              READY
            </li>
            <li className={ formValue.status === 'done' ? 'posted posted-status' : 'posted-status posted-transparent' }>
              DONE
            </li>
            
          </ul>
        </div>
      )}
      </>
    
    case 'STOCK_REQUEST':
      return <>
      {formValue.status !== ' ' && (
        <div id='status-container flex'>
          <ul className='inner-wrapper items-center'>
            <li className={ formValue.status === 'draft' ? 'draft-disabled first draft draft-status' : 'first draft-status draft-transparent' }>
              DRAFT
            </li>
            <li className = {formValue.status === 'stock_request' ? 'middle middle-status' : 'middle-status middle-transparent' }>
              STOCK REQUEST
            </li>
            {formValue.status === 'request_in_progress' && <li className = {formValue.status === 'request_in_progress' ? 'middle middle-status' : 'middle-status middle-transparent' }>
              REQUEST IN PROGRESS
            </li>}
            <li className={ formValue.status === 'done' ? 'posted posted-status' : 'posted-status posted-transparent' }>
              DONE
            </li>
            
          </ul>
        </div>
      )}
      </>

  case 'STOCK_COUNT':
    return <>
    {formValue.status !== ' ' && (
      <div id='status-container flex'>
        <ul className='inner-wrapper items-center'>
          <li className={ formValue.status === 'draft' ? 'draft-disabled first draft draft-status' : 'first draft-status draft-transparent' }>
            DRAFT
          </li>
          <li className = {formValue.status === 'in_progress' ? 'middle middle-status' : 'middle-status middle-transparent' }>
            IN PROGRESS
          </li>
          <li className={ formValue.status === 'validated' ? 'posted posted-status' : 'posted-status posted-transparent' }>
            VALIDATED
          </li>
          
        </ul>
      </div>
    )}
    </>

  case 'SALES_ORDER':
    return <>
    {formValue.status !== ' ' && (
      <div id='status-container flex'>
        <ul className='inner-wrapper items-center'>
          <li className={ formValue.status === 'quotation' ? 'draft-disabled first draft draft-status' : 'first draft-status draft-transparent' }>
            QUOTATION
          </li>
          <li className = {formValue.status === 'quotation_sent' ? 'middle middle-status' : 'middle-status middle-transparent' }>
            QUOTATION SENT
          </li>
          <li className={ formValue.status === 'sales_order' ? 'posted posted-status' : 'posted-status posted-transparent' }>
            SALES ORDER
          </li>
        </ul>
      </div>
    )}
    </>

  case 'SESSION':
    return <>
    {formValue.status !== ' ' && (
      <div id='status-container flex'>
        <ul className='inner-wrapper items-center'>
          <li className={ formValue.status === 'in_progress' ? 'draft-disabled first draft draft-status' : 'first draft-status draft-transparent' }>
            IN PROGRESS
          </li>
          <li className = {formValue.status === 'closing' ? 'middle middle-status' : 'middle-status middle-transparent' }>
            CLOSING CONTROL
          </li>
          <li className={ formValue.status === 'closed_posted' ? 'posted posted-status' : 'posted-status posted-transparent' }>
            CLOSED & POSTED
          </li>
        </ul>
      </div>
    )}
    </>

  case 'EXPENSES':
    return <>
    {formValue.status !== ' ' && (
      <div id='status-container flex'>
        <ul className='inner-wrapper items-center'>
          <li className={ formValue.status === 'to_submit' ? 'draft-disabled first draft draft-status' : 'first draft-status draft-transparent' }>
            TO SUBMIT
          </li>
          <li className = {formValue.status === 'submitted' ? 'middle middle-status' : 'middle-status middle-transparent' }>
            SUBMITTED
          </li>
          <li className = {formValue.status === 'approved' ? 'middle middle-status' : 'middle-status middle-transparent' }>
            APPROVED
          </li>
          {/* <li className = {formValue.status === 'posted' ? 'middle middle-status' : 'middle-status middle-transparent' }>
            POSTED
          </li> */}
          {formValue.status !== 'refused' && <li className={ formValue.status === 'paid' ? 'posted posted-status' : 'posted-status posted-transparent' }>
            PAID
          </li>}
          {formValue.status === 'refused' && 
            <li className={ formValue.status === 'refused' ? 'posted posted-status' : 'posted-status posted-transparent' }>
            REFUSED
          </li>}
        </ul>
      </div>
    )}
    </>

case 'SALES_UPDATE':
  return <>
  {formValue.status !== ' ' && (
    <div id='status-container flex'>
      <ul className='inner-wrapper items-center'>
        <li className={ formValue.status === 'to_submit' ? 'draft-disabled first draft draft-status' : 'first draft-status draft-transparent' }>
          TO SUBMIT
        </li>
        <li className={ formValue.status === 'submitted' ? 'posted posted-status' : 'posted-status posted-transparent' }>
          SUBMITTED
        </li>
      </ul>
    </div>
  )}
  </>
  }
  
}

export default StatusComponent;